import React from "react";

export default function Help() {
  return (
    <div className="p-8">
      <h1 className="text-xl font-medium">Help</h1>
    </div>
  );
}
